module.exports = __webpack_public_path__ + "static/img/ind_ban_012.09fd4467.jpeg";